import { text } from "../constants/tailwind-theme";
import logo from '../assets/images/logo.png'

const Header = () => {

    return (
        <div className="flex flex-row items-center justify-center bg-white h-20">

            {/* LOGO */}
            <div className=" w-6/12 md:w-2/12 lg:w-2/12 p-4">
                <img src={logo} alt="logo" />
            </div>
        </div>
    )
}

export default Header;